// extracted by mini-css-extract-plugin
export var configurationSection = "_zc-0";